import { Info, Check, Alert, Warning } from "@vibe/icons";

export const defaultIconMap = {
  normal: Info,
  positive: Check,
  negative: Alert,
  warning: Warning,
  dark: Info
};
